// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styled_wrapper__3_z6F","left":"styled_left__3dUQI","wrapperImg":"styled_wrapperImg__1A11a","right":"styled_right__ALetW"};